import React from "react";

const INLINE = /(\[([^\]]+)\]\((https?:\/\/[^\s)]+)\))|(\*\*([^*]+)\*\*)|(\*([^*]+)\*)|(@(Steven|Richard))/;

const inline = (text, kb) => {
  const nodes = [];
  let rest = text;
  let i = 0;
  while (rest && rest.length) {
    const m = rest.match(INLINE);
    if (!m) { nodes.push(rest); break; }
    if (m.index > 0) nodes.push(rest.slice(0, m.index));
    if (m[1]) nodes.push(<a key={`${kb}-${i}`} href={m[3]} target="_blank" rel="noreferrer" className="font-medium text-[#0EA5A4] underline decoration-dotted underline-offset-2">{m[2]}</a>);
    else if (m[4]) nodes.push(<strong key={`${kb}-${i}`}>{m[5]}</strong>);
    else if (m[6]) nodes.push(<em key={`${kb}-${i}`}>{m[7]}</em>);
    else if (m[8]) nodes.push(<span key={`${kb}-${i}`} className="rounded bg-[#E0A82E]/15 px-1 font-semibold text-[#8A6314]">@{m[9]}</span>);
    rest = rest.slice(m.index + m[0].length);
    i++;
  }
  return nodes;
};

export const MiniMarkdown = ({ text, className = "" }) => {
  const lines = String(text || "").split(/\r?\n/);
  const blocks = [];
  let list = null;
  const flush = () => { if (list) { blocks.push(list); list = null; } };
  lines.forEach((ln, idx) => {
    const h = ln.match(/^(#{1,3})\s+(.*)$/);
    const b = ln.match(/^\s*[-*]\s+(.*)$/);
    const n = ln.match(/^\s*\d+\.\s+(.*)$/);
    if (h) { flush(); const S = h[1].length === 1 ? "text-base font-bold" : h[1].length === 2 ? "text-sm font-bold" : "text-sm font-semibold"; blocks.push(<p key={idx} className={`${S} text-[#0D1B2A]`}>{inline(h[2], idx)}</p>); }
    else if (b) { if (!list || list.type !== "ul") { flush(); list = { type: "ul", items: [] }; } list.items.push(<li key={idx}>{inline(b[1], idx)}</li>); }
    else if (n) { if (!list || list.type !== "ol") { flush(); list = { type: "ol", items: [] }; } list.items.push(<li key={idx}>{inline(n[1], idx)}</li>); }
    else if (ln.trim() === "") { flush(); }
    else { flush(); blocks.push(<p key={idx}>{inline(ln, idx)}</p>); }
  });
  flush();
  const rendered = blocks.map((blk, i) =>
    blk && blk.type === "ul" ? <ul key={`ul-${i}`} className="list-disc space-y-0.5 pl-5">{blk.items}</ul>
      : blk && blk.type === "ol" ? <ol key={`ol-${i}`} className="list-decimal space-y-0.5 pl-5">{blk.items}</ol>
        : blk
  );
  return <div className={`space-y-1.5 text-sm leading-relaxed text-[#334155] ${className}`}>{rendered}</div>;
};
